export const CURRENCY = "£";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = "";

export const allowedFileTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "image/*": [".png", ".jpeg", ".jpg"],
};
export const allowedDocTypes = {
  "application/pdf": [".pdf"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
};
export const allowedImageTypes = {
  "image/*": [".png", ".jpeg", ".jpg", ".jfif", ".webp"],
};

export const ROLES = {
  EDUCATOR: "educator",
  STUDENT: "student",
  SOCIAL_WORKER: "social-worker",
  SCHOOL: "school",
  ADMIN: "admin",
};

const GENDER_OPTIONS_ENUMS = {
  MALE: "male",
  FEMALE: "female",
  NON_BINARY: "non-binary",
  TRANSGENDER: "transgender",
  PREFER_NOT_TO_SAY: "prefer-not-to-say",
};
export const GENDER_OPTIONS = [
  { label: "Male", value: GENDER_OPTIONS_ENUMS.MALE },
  { label: "Female", value: GENDER_OPTIONS_ENUMS.FEMALE },
  { label: "Non-Binary", value: GENDER_OPTIONS_ENUMS.NON_BINARY },
  { label: "Transgender", value: GENDER_OPTIONS_ENUMS.TRANSGENDER },
  { label: "Prefer Not to Say", value: GENDER_OPTIONS_ENUMS.PREFER_NOT_TO_SAY },
];

const ETHNICITY_OPTIONS_ENUMS = {
  WHITE: "white",
  AFRICAN: "african",
  ASIAN: "asian",
  EUROPEAN: "european",
  LATINO: "latino",
  MIDDLE_EASTERN: "middle-eastern",
  NATIVE_AMERICAN: "native-american",
  AFRICAN_AMERICAN: "african-american",
  OTHER: "other",
};
export const ETHNICITY_OPTIONS = [
  { label: "White", value: ETHNICITY_OPTIONS_ENUMS.WHITE },
  { label: "African", value: ETHNICITY_OPTIONS_ENUMS.AFRICAN },
  { label: "Asian", value: ETHNICITY_OPTIONS_ENUMS.ASIAN },
  { label: "European", value: ETHNICITY_OPTIONS_ENUMS.EUROPEAN },
  { label: "Latino", value: ETHNICITY_OPTIONS_ENUMS.LATINO },
  { label: "Middle Eastern", value: ETHNICITY_OPTIONS_ENUMS.MIDDLE_EASTERN },
  { label: "Native American", value: ETHNICITY_OPTIONS_ENUMS.NATIVE_AMERICAN },
  {
    label: "African American",
    value: ETHNICITY_OPTIONS_ENUMS.AFRICAN_AMERICAN,
  },
  { label: "Other", value: ETHNICITY_OPTIONS_ENUMS.OTHER },
];

export const ActivityType = {
  GENERAL: "general",
  MOOD: "mood",
  ALL: "all",
};

export const USER_STATUS = {
  ACTIVE: "active",
  SYSTEM_DEACTIVATED: "system-deactivated",
};
export const ActivityTypeOptions = [
  { label: "General", value: ActivityType.GENERAL },
  { label: "Mood", value: ActivityType.MOOD },
  { label: "All", value: ActivityType.ALL },
];

export const QUESTION_SECTION_TYPE = {
  GENERAL: "general",
  ACTIVITY: "activity",
  MOOD: "mood",
  PROMPTS: "prompts",
};
// CAPITALIZE
export const QUESTION_FORMAT_TYPE = {
  MCQ: "mcq",
  TRUE_FALSE: "true_false",
  DESCRIPTIVE: "descriptive",
  FILL_IN_THE_BLANKS: "fill_in_the_blanks",
};
export const QUESTION_FORMAT_TYPE_OPTIONS = [
  { label: "MCQ", value: QUESTION_FORMAT_TYPE.MCQ },
  { label: "True/False", value: QUESTION_FORMAT_TYPE.TRUE_FALSE },
  { label: "Descriptive", value: QUESTION_FORMAT_TYPE.DESCRIPTIVE },
  {
    label: "Fill in the Blanks",
    value: QUESTION_FORMAT_TYPE.FILL_IN_THE_BLANKS,
  },
];

export const QUESTION_SECTION_TYPE_OPTIONS = [
  { label: "General", value: QUESTION_SECTION_TYPE.GENERAL },
  { label: "Activity", value: QUESTION_SECTION_TYPE.ACTIVITY },
  { label: "Mood", value: QUESTION_SECTION_TYPE.MOOD },
  { label: "Prompts", value: QUESTION_SECTION_TYPE.PROMPTS },
];

export const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];
export const DEFENDER_STATUS_OPTIONS_ENUMS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

// KOWALA DEFENDER STATUS OPTIONS

export const DEFENDER_STATUS_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Active", value: DEFENDER_STATUS_OPTIONS_ENUMS.ACTIVE },
  { label: "Inactive", value: DEFENDER_STATUS_OPTIONS_ENUMS.INACTIVE },
];

export const FLAG = {
  NONE: "none",
  USER: "user",
  ALERT: "alert",
  COUNSELING: "counseling",
  SESSION: "session",
  ONBOARDING: "onboarding",
};
